import React, { useState, useRef } from 'react';
import { FiClock } from 'react-icons/fi';
import { formatCurrency, formatDate } from '../utils/formatters';

/**
 * Compact "last N transacted prices" reference for Sale/Purchase Invoice and
 * Quotation lines. Renders only a small clock indicator inline; the actual price
 * list appears in a floating popover ON HOVER (no permanent clutter). Purely
 * informational, read-only.
 * `hints`: array of { price, date, docNumber, partyName } (newest first), or
 * null while loading, or [] when there's no history.
 */
const ItemPriceHints = ({ hints }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const ref = useRef(null);

  if (hints == null || hints.length === 0) return null;   // loading or no history → show nothing

  const handleEnter = () => {
    const r = ref.current?.getBoundingClientRect();
    if (r) setPos({ top: r.bottom + 2, left: r.left });
    setShow(true);
  };

  return (
    <span
      ref={ref}
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 2, cursor: 'help', fontSize: 10.5, color: '#b08a95' }}
    >
      <FiClock size={11} />
      <span>last prices</span>

      {show && (
        <div
          style={{
            position: 'fixed', top: pos.top, left: pos.left, zIndex: 5000,
            background: '#fff', border: '1px solid #e0d3d8', borderRadius: 8,
            boxShadow: '0 8px 26px rgba(0,0,0,0.18)', padding: '8px 10px', minWidth: 210, maxWidth: 320,
          }}
        >
          <div style={{ fontSize: 11, fontWeight: 700, color: '#800020', marginBottom: 5 }}>
            Last {hints.length} price{hints.length > 1 ? 's' : ''}
          </div>
          {hints.map((h, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 14, fontSize: 12, color: '#444', padding: '3px 0', borderTop: i ? '1px solid #f2f2f2' : 'none' }}>
              <strong style={{ color: '#222', whiteSpace: 'nowrap' }}>{formatCurrency(h.price)}</strong>
              <span style={{ color: '#888', textAlign: 'right' }}>
                {formatDate(h.date)}{h.partyName ? ` · ${h.partyName}` : ''}
              </span>
            </div>
          ))}
        </div>
      )}
    </span>
  );
};

export default ItemPriceHints;
